import React, { useContext } from 'react';
import Modal from '../../styled/Modal';
import navigationContext from '../../../context/navigationContext';
import { NAVIGATION_KEYS } from '../../../utils/constants';
import axiosFetch from '../../../context/axiosFetch';
import { PAMBeaconButton } from '../../../utils/beacon';
import styles from './LegalAgreementModal.module.scss';
import TRP from '../TRP';

type Props = {};

const LegalAgreementModal: React.FC<Props> = () => {
  const context = useContext(navigationContext);

  const selectedAgreement = () => {
    axiosFetch(context.urls.userConsentEndpoint, { method: 'POST' })
      .then((res) => context.legalAgreementModal.handleToggle())
      .catch(
        (err) =>
          (window.location.pathname =
            'personal-investing/tools/pamwebsite/error')
      );
  };

  return (
    <Modal
      className={styles['modal-background']}
      contextKey={NAVIGATION_KEYS.LEGAL_AGREEMENT_MODAL}
      popUpClassName={styles['modal-width']}>
      <div className={styles['content']}>
        <div className={styles['title']}>
          Online Account Information Agreement
        </div>
        <div className={styles['description']}>
          <p>
            This Online Account Information Agreement ("<b>Online Agreement</b>
            ") between you and <TRP /> Associates, Inc. ("
            <b>
              <TRP />
            </b>
            ") states the terms and conditions applicable to use of the online
            account information access service ("<b>Service</b>") offered by{' '}
            <TRP />
            regarding certain accounts as further described below ("
            <b>Account(s)</b>").
            <br />
            <br />
            <u>Accounts</u>. For purposes of investment advisory clients of{' '}
            <TRP />
            ("<b>Client(s)</b>") using the Service, the term "Account(s)" shall
            refer to a Client's investment advisory account(s) with <TRP />
            ("<b>IA Account(s)</b>") as well as any brokerage account(s)
            maintained by a Client with <TRP /> Investment Services, Inc. ("
            <b>TRP Brokerage</b>") or any mutual fund account(s) maintained by a
            Client with one or more of the <TRP /> mutual funds ("
            <b>Price Funds</b>"), which Accounts are accessible via the Service.
            This Online Agreement supplements the terms and conditions of a
            Client's Investment Advisory Agreement(s) with
            <TRP /> and any other agreements with TRP Brokerage or the Price
            Funds.
            <br />
            <br />
            Information provided for all IA Accounts is provided in &quot;read
            only&quot; format. However, Clients may access all of their TRP
            Brokerage and Price Fund Accounts through the Service. As a result,
            Clients will be able to trade in all such Accounts. Client agrees,
            however, that he/she will not trade in any TRP Brokerage or Price
            Fund Account if such Account is used in connection with <TRP />
            's activities as discretionary manager for the Client's IA
            Account(s). Clients who wish to revise investment guidelines or
            other instructions regarding an IA Account should contact the
            Investment Liaison assigned to the IA Account (&quot;
            <b>Investment Liaison</b>&quot;).
            <br />
            <br />
            <u>Third-Party Users</u>. For purposes of any third party (ies)
            authorized by a Client to receive access to the Service ("
            <b>Third Party User(s)</b>"), the term "Account(s)" shall refer only
            to the applicable Client's IA Account(s). Third-Party Users will not
            have access via the Service to TRP Brokerage or Price Fund Accounts
            maintained in the Client's name.
            <br />
            <br />
            <u>Confidentiality of Account Information</u>. In the event a Client
            authorizes <TRP /> to provide the Service to a Third Party User,
            <TRP /> will issue Access ID Information and provide the Service to
            such Third Party User until such time as the Client notifies <TRP />
            to discontinue the Service to any such Third Party User.
            <br />
            <br />
            Each Client and Third Party User agrees to accept responsibility for
            protecting the confidentiality of user name, password, and other
            information necessary to access Account information as provided by{' '}
            <TRP /> ("<b>Access ID Information</b>"). To prevent unauthorized
            access to the Service, each Client and Third Party User agrees to
            notify <TRP /> immediately upon loss of Access ID Information or in
            the event he/she becomes aware of any unauthorized use of Access ID
            Information.
            <br />
            <br />
            <b>
              Any party who enters valid Access ID Information provided to
              Clients or to Third Party Users will receive the Service regarding
              applicable Account information. In addition, any party who enters
              valid Access ID Information provided to a Client will have trading
              capacity regarding any applicable TRP Brokerage or Price Fund
              Account(s).
            </b>
            Each Client agrees that he/she will not hold <TRP /> or its
            affiliates responsible for any loss that results from <TRP />{' '}
            issuing Access ID Information as described above, providing the
            Service, or acting upon instructions received regarding TRP
            Brokerage or Price Fund Accounts, even if an unauthorized person is
            able to access or perform transactions regarding such Accounts.
            <br />
            <br />
            <u>Disclaimer Regarding Information Provided</u>. The IA Account
            information displayed is not reconciled on a daily basis. In
            addition, transactions regarding Price Funds are reported on a one
            day delay.
            <b>
              Therefore, daily information (including portfolio holdings and
              cash balances) may not be accurate.
            </b>
            For this reason, <TRP /> makes no representations as to the
            accuracy, timeliness, or completeness of information provided via
            the Service and assumes no liability or responsibility for any
            errors or omissions in the content of such information. (Monthly
            information is provided as of the close of business on the date
            displayed with such information.)
            <br />
            <br />
            <b>
              Each Client acknowledges that prior to taking any action in
              reliance on information provided via the Service, he/she should
              contact the Investment Liaison. Each Third Party acknowledges that
              prior to making any recommendation based on the information
              provided via the Service, he/she will validate the information
              upon which the recommendation is based.
            </b>
            <br />
            <br />
            <u>Additional Information</u>. If you have any questions or require
            additional information regarding the Service, please contact the
            Investment Liaison.
            <br />
            <br />
            <b>
              <PAMBeaconButton
                variant="tertiary"
                link-target="_blank"
                link-href="https://www.troweprice.com/corporate/en/utility/terms-of-use.html">
                T. Rowe Price's Terms of Use statement and policies
              </PAMBeaconButton>
            </b>
            <br />
            <br />
            <u>Acceptance</u>. Please click on the button below to acknowledge
            your understanding and acceptance of the terms of this Agreement.
          </p>
        </div>
        <div className="action-zone-align-left" slot="action-zone">
          <PAMBeaconButton
            variant="secondary"
            onClick={() => selectedAgreement()}>
            I accept the terms of this Agreement
          </PAMBeaconButton>
        </div>
      </div>
    </Modal>
  );
};

export default LegalAgreementModal;
